import React from "react";
import { withStyles } from "@material-ui/core";
import yellow from "@material-ui/core/colors/yellow.js";
import Button from "@material-ui/core/Button";

export default withStyles({
  root: {
    backgroundColor: yellow[600],
    textTransform: "none",
    color: "#00213A",
    "&:hover": {
      backgroundColor: yellow[800],
    },
    "&:disabled": {
      backgroundColor: yellow[800],
      opacity: "0.6",
    },
  },
})((props) => <Button {...props} variant="contained" />);
